import { LocalDate } from "@js-joda/core";
import * as React from "react";
import { API } from "../API";
import { ProfileScreen } from "../components/ProfileScreen";
import { getDevicePhotoForProfile } from "../get_device_photo";
import { isLoading } from "../Loading";
import * as messages from "../messages";
import { retryableModalNetworkRequest } from "../NetworkRequest";
import { AppState } from "../system/AppState";
import { ActivityStateMixin, ActivityStateMixinState } from "./ActivityStateMixin";

interface ProfileActivityProps {
  api: API;
  appState: AppState;
  onBackClick: () => void;
}

interface ProfileActivityState {
  mixin: ActivityStateMixinState;
  isAddressDialogOpen: boolean;
}

export class ProfileActivity extends React.Component<ProfileActivityProps, ProfileActivityState> {
  constructor(props: ProfileActivityProps) {
    super(props);

    this.activityStateMixin = new ActivityStateMixin(
      (state) =>
        this.setState((_prevState: ProfileActivityState) => ({
          mixin: state,
        })),
      this.props.appState
    );

    this.state = {
      mixin: this.activityStateMixin.initialState(),
      isAddressDialogOpen: false,
    };
  }

  private activityStateMixin: ActivityStateMixin;

  componentWillUnmount() {
    this.activityStateMixin.componentWillUnmount();
  }

  handleProfileUpload = async (): Promise<void> => {
    const dataUri = await getDevicePhotoForProfile();
    if (dataUri === null) {
      // User canceled
      return;
    }

    await retryableModalNetworkRequest(() => this.props.api.caregiverUploadPhoto(dataUri), false);

    this.props.appState.handleCaregiverUpdate({ photoUrl: dataUri });
  };

  handleProfileAddressChange = async (address: string, geo: messages.Geo): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        address: address,
        addressGeoLocation: geo,
      });
    }, true);
  };

  handleProfileBirthdayChange = async (birthday: LocalDate): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        birthDateDate: birthday,
      });
    }, true);
  };

  handleProfileLanguagesChange = async (languages: string[]): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        languages: languages,
      });
    }, true);
  };

  handleProfileFirstNameChange = async (firstName: string): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        firstName: firstName,
      });
    }, true);
  };

  handleProfileMiddleNameChange = async (middleName: string): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        middleName: middleName,
      });
    }, true);
  };

  handleProfileLastNameChange = async (lastName: string): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        lastName: lastName,
      });
    }, true);
  };

  handleProfileHomePhoneChange = async (homePhone: string): Promise<void> => {
    await retryableModalNetworkRequest(() => {
      return this.props.api.caregiverUpdateProfile({
        homePhone: homePhone,
      });
    }, true);
  };

  handleAddressInputClick = (): void => {
    this.setState({ isAddressDialogOpen: true });
  };

  handleRequestCloseAddressDialog = (): void => {
    this.setState({ isAddressDialogOpen: false });
  };

  render() {
    if (isLoading(this.state.mixin.appCaregiverState)) {
      // TODO Better loading GUI
      return <div>Loading...</div>;
    }

    return (
      <ProfileScreen
        caregiver={this.state.mixin.appCaregiverState.caregiver}
        onBackClick={this.props.onBackClick}
        isAddressDialogOpen={this.state.isAddressDialogOpen}
        onProfileUpload={this.handleProfileUpload}
        onAddressChange={this.handleProfileAddressChange}
        onBirthdayChange={this.handleProfileBirthdayChange}
        onLanguagesChange={this.handleProfileLanguagesChange}
        onFirstnameChange={this.handleProfileFirstNameChange}
        onMiddleNameChange={this.handleProfileMiddleNameChange}
        onLastNameChange={this.handleProfileLastNameChange}
        onHomePhoneChange={this.handleProfileHomePhoneChange}
        onAddressInputClick={this.handleAddressInputClick}
        onRequestCloseAddressDialog={this.handleRequestCloseAddressDialog}
      />
    );
  }
}
